/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TodayPillarDto
 */
export interface TodayPillarDto {
    /**
     * 
     * @type {string}
     * @memberof TodayPillarDto
     */
    category: TodayPillarDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof TodayPillarDto
     */
    displayName: string;
    /**
     * Points earned from completed tasks in this pillar today
     * @type {number}
     * @memberof TodayPillarDto
     */
    completedPoints: number;
    /**
     * Configured pillar weight when at least one task exists today; otherwise 0
     * @type {number}
     * @memberof TodayPillarDto
     */
    totalPoints: number;
}


/**
 * @export
 */
export const TodayPillarDtoCategoryEnum = {
    Medication: 'medication',
    Nutrition: 'nutrition',
    Hydration: 'hydration',
    Exercise: 'exercise',
    Lifestyle: 'lifestyle'
} as const;
export type TodayPillarDtoCategoryEnum = typeof TodayPillarDtoCategoryEnum[keyof typeof TodayPillarDtoCategoryEnum];


/**
 * Check if a given object implements the TodayPillarDto interface.
 */
export function instanceOfTodayPillarDto(value: object): value is TodayPillarDto {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('completedPoints' in value) || value['completedPoints'] === undefined) return false;
    if (!('totalPoints' in value) || value['totalPoints'] === undefined) return false;
    return true;
}

export function TodayPillarDtoFromJSON(json: any): TodayPillarDto {
    return TodayPillarDtoFromJSONTyped(json, false);
}

export function TodayPillarDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TodayPillarDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'],
        'displayName': json['displayName'],
        'completedPoints': json['completedPoints'],
        'totalPoints': json['totalPoints'],
    };
}

export function TodayPillarDtoToJSON(json: any): TodayPillarDto {
    return TodayPillarDtoToJSONTyped(json, false);
}

export function TodayPillarDtoToJSONTyped(value?: TodayPillarDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'displayName': value['displayName'],
        'completedPoints': value['completedPoints'],
        'totalPoints': value['totalPoints'],
    };
}

